const linkageTypeLabels = {
  0: 'Pago Arriendos',
  1: 'Cobro Arriendos',
  2: 'Gastos Comunes',
  3: 'Retiro Dividendo',
  4: 'Prestamo Otorgado',
  5: 'Cobro Cuota Prestamo',
  6: 'Credito Consumo',
  7: 'Pago Cuota Prestamo',
  8: 'Pago Patente Comercial',
  9: 'Pago Contribuciones',
  10: 'Aporte Transitorio Socio',
  11: 'Devolucion Aporte Transitorio',
  12: 'Rendicion Gastos',
  13: 'Invoice Compra',
  14: 'Invoice Venta',
  15: 'Finiquitos',
  16: 'Inversiones DAP',
  17: 'Inversiones FFMM',
  18: 'Inversiones Otras',
  19: 'Acciones en Bolsa',
  20: 'Criptomonedas',
  21: 'Otros Valores Negociables',
  22: 'Ajuste Existencias',
  23: 'Pago Año Anterior',
  24: 'Cobro Año Anterior',
  25: 'Vinculacion Generica Cargo',
  26: 'Vinculacion Generica Abono',
  27: 'Anticipo Agente de Aduana',
  28: 'Anticipo de Sueldo',
  29: 'Multas',
  30: 'Devolución Agente Aduana',
  31: 'Previred año anterior',
  32: 'Remuneración año anterior',
  33: 'Aporte Empresa Relacionada',
  34: 'Devolución Empresa Relacionada',
  35: 'Invoice Importaciones',
  36: 'Devolución de Impuestos',
}

export default linkageTypeLabels
